// Downloads.js - Adam International Academy Documents Version
import React, { useState, useEffect, useRef } from 'react';
import './Downloads.css';

const Downloads = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  // Intersection Observer for scroll animations - DÜZELTİLDİ
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => ({
              ...prev,
              [entry.target.dataset.section]: true
            }));
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' } // threshold düşürüldü, rootMargin eklendi
    );

    Object.values(sectionRefs.current).forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      Object.values(sectionRefs.current).forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  // TÜM SECTION'LARI BAŞLANGIÇTA GÖRÜNÜR YAP
  useEffect(() => {
    // Sayfa yüklendiğinde tüm section'ları görünür yap
    const allSections = [
      'search', 'categories', 'downloads', 'stats', 'cta'
    ];
    
    const initialVisible = {};
    allSections.forEach(section => {
      initialVisible[section] = true;
    });
    
    setVisibleSections(initialVisible);
  }, []);

  // Categories from documents
  const categories = [
    { id: 'all', name: 'All Resources', icon: '📦', count: 18 },
    { id: 'journals', name: 'Academic Journals', icon: '📚', count: 4 },
    { id: 'reports', name: 'Annual Reports', icon: '📊', count: 3 },
    { id: 'brochures', name: 'Program Brochures', icon: '📄', count: 5 },
    { id: 'catalogs', name: 'Training Catalogs', icon: '📑', count: 3 },
    { id: 'forms', name: 'Application Forms', icon: '📝', count: 3 }
  ];

  // Downloadable resources from Adam International Academy documents
  const downloads = [
    // Academic Journals
    {
      id: 1,
      title: 'Adam International Journal - Volume 1, Issue 1',
      description: 'Inaugural peer-reviewed scientific journal featuring research on sustainable development, economic policy, and educational innovation. Published quarterly.',
      category: 'journals',
      fileType: 'PDF',
      fileSize: '12.5 MB',
      publishDate: '2026-01-15',
      downloads: 1250,
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      authors: 'Prof. Dr. Abdulnasir Munir, Prof. Dr. Ayşe Demir',
      pages: 124,
      issn: '2757-8912'
    },
    {
      id: 2,
      title: 'Adam International Journal - Volume 1, Issue 2',
      description: 'Special issue on "Multilingual Education and Capacity Development" with contributions from international experts across 15 countries.',
      category: 'journals',
      fileType: 'PDF',
      fileSize: '14.2 MB',
      publishDate: '2026-04-20',
      downloads: 890,
      image: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      authors: 'Prof. Dr. Samir Albuny, Dr. Amanda White',
      pages: 156,
      issn: '2757-8912'
    },

    // Annual Reports
    {
      id: 3,
      title: 'Annual Report 2024: Impact and Achievements',
      description: 'Comprehensive report on Adam International Academy\'s activities, partnerships, student achievements, and contributions to SDG 2030.',
      category: 'reports',
      fileType: 'PDF',
      fileSize: '18.7 MB',
      publishDate: '2025-02-28',
      downloads: 2100,
      image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 84,
      highlights: ['2,500+ students', '30+ countries', '50+ partners']
    },
    {
      id: 4,
      title: 'Annual Report 2025: Global Expansion',
      description: 'Detailed overview of AIA\'s expansion into African markets, new university partnerships, and program developments.',
      category: 'reports',
      fileType: 'PDF',
      fileSize: '22.3 MB',
      publishDate: '2026-02-15',
      downloads: 1560,
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 96,
      highlights: ['New partnerships in Africa', '8 new programs', '100+ faculty']
    },

    // Program Brochures
    {
      id: 5,
      title: 'Master\'s & PhD Programs Brochure',
      description: 'Complete guide to postgraduate programs including Political Science, International Relations, Strategic Studies, and International Law.',
      category: 'brochures',
      fileType: 'PDF',
      fileSize: '8.5 MB',
      publishDate: '2026-01-10',
      downloads: 1870,
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 32,
      languages: ['English', 'Arabic', 'Turkish']
    },
    {
      id: 6,
      title: 'Sustainable Development Programs',
      description: 'Detailed information on SDG-aligned courses, capacity development initiatives, and professional diplomas.',
      category: 'brochures',
      fileType: 'PDF',
      fileSize: '7.8 MB',
      publishDate: '2026-01-25',
      downloads: 1430,
      image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 28,
      sdgFocus: ['SDG 4', 'SDG 5', 'SDG 8', 'SDG 13']
    },
    {
      id: 7,
      title: 'Executive Education Brochure',
      description: 'Programs designed for senior professionals, policymakers, and government officials.',
      category: 'brochures',
      fileType: 'PDF',
      fileSize: '6.2 MB',
      publishDate: '2026-02-05',
      downloads: 980,
      image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 24,
      targetAudience: ['Policymakers', 'Government Officials', 'Senior Managers']
    },
    {
      id: 8,
      title: 'Professional Diplomas Catalog',
      description: 'Overview of 60-300 hour professional diploma programs across 9 sectors.',
      category: 'brochures',
      fileType: 'PDF',
      fileSize: '9.1 MB',
      publishDate: '2026-02-20',
      downloads: 1120,
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 36,
      sectors: 9
    },

    // Training Catalogs
    {
      id: 9,
      title: 'Training Programs 2026 - Full Catalog',
      description: 'Complete catalog of all training programs for 2026 including institutional development, financial management, operations, engineering, and technology.',
      category: 'catalogs',
      fileType: 'PDF',
      fileSize: '15.3 MB',
      publishDate: '2026-01-05',
      downloads: 2450,
      image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 120,
      programs: 50
    },
    {
      id: 10,
      title: 'Institutional & Organizational Development',
      description: 'Specialized catalog featuring programs in Risk Management, Corporate Governance (GRC), Diplomacy, HR, and Leadership.',
      category: 'catalogs',
      fileType: 'PDF',
      fileSize: '10.8 MB',
      publishDate: '2026-01-18',
      downloads: 1670,
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 48,
      programCount: 14
    },
    {
      id: 11,
      title: 'Technology & Innovation Programs',
      description: 'Catalog featuring AI, Digital Transformation, Data Science, Cybersecurity, and Business Intelligence courses.',
      category: 'catalogs',
      fileType: 'PDF',
      fileSize: '9.5 MB',
      publishDate: '2026-02-12',
      downloads: 1350,
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 36,
      techPrograms: ['AI', 'Data Science', 'Cybersecurity']
    },

    // Application Forms
    {
      id: 12,
      title: 'Admission Application Form - Graduate Programs',
      description: 'Official application form for Master\'s and PhD programs. Includes personal information, academic background, and statement of purpose sections.',
      category: 'forms',
      fileType: 'DOCX',
      fileSize: '0.8 MB',
      publishDate: '2026-01-08',
      downloads: 3120,
      image: 'https://images.unsplash.com/photo-1586281380117-5a60ae2050cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      format: 'Microsoft Word',
      pages: 6
    },
    {
      id: 13,
      title: 'Scholarship Application Form',
      description: 'Application form for scholarship opportunities at Adam International Academy. Requires academic records and personal statement.',
      category: 'forms',
      fileType: 'DOCX',
      fileSize: '0.7 MB',
      publishDate: '2026-01-15',
      downloads: 2540,
      image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      format: 'Microsoft Word',
      pages: 5
    },
    {
      id: 14,
      title: 'Partnership Application Form',
      description: 'For institutions interested in collaborating with Adam International Academy as strategic partners.',
      category: 'forms',
      fileType: 'PDF',
      fileSize: '1.2 MB',
      publishDate: '2026-02-01',
      downloads: 890,
      image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      format: 'PDF (fillable)',
      pages: 4
    },

    // Research Publications
    {
      id: 15,
      title: 'Capacity Development Best Practices: A Guide',
      description: 'Practical guide for designing and delivering effective capacity development interventions. Based on AIA\'s 5 years of experience.',
      category: 'journals',
      fileType: 'PDF',
      fileSize: '5.6 MB',
      publishDate: '2026-03-10',
      downloads: 720,
      image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      authors: 'Dr. M. Haydar, Prof. Dr. Sarah Wilson',
      pages: 68
    },
    {
      id: 16,
      title: 'Multilingual Education: Strategies and Case Studies',
      description: 'Research publication on effective multilingual education approaches, with case studies from Africa, Middle East, and Europe.',
      category: 'journals',
      fileType: 'PDF',
      fileSize: '8.9 MB',
      publishDate: '2026-02-28',
      downloads: 680,
      image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      authors: 'Prof. Dr. Samir Albuny, Dr. Amanda White',
      pages: 92
    },
    {
      id: 17,
      title: 'SDG 2030 Implementation Handbook',
      description: 'Comprehensive handbook for organizations seeking to align their operations with Sustainable Development Goals.',
      category: 'reports',
      fileType: 'PDF',
      fileSize: '16.4 MB',
      publishDate: '2026-01-30',
      downloads: 1950,
      image: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 156,
      sdgs: 'All 17 SDGs'
    },

    // Premium Categories Brochure
    {
      id: 18,
      title: 'Premium Programs Brochure',
      description: 'Information on Mini MBA Series, Corporate Sustainability, Emotional Intelligence, and Institutional Flexibility programs.',
      category: 'brochures',
      fileType: 'PDF',
      fileSize: '7.3 MB',
      publishDate: '2026-03-05',
      downloads: 840,
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      downloadUrl: '#',
      pages: 22,
      premiumCategories: ['Mini MBA', 'Sustainability', 'Emotional Intelligence']
    }
  ];

  // Stats from documents
  const stats = [
    { number: '15,000+', label: 'Total Downloads', icon: '📥' },
    { number: '18', label: 'Resources Available', icon: '📚' },
    { number: '98%', label: 'User Satisfaction', icon: '⭐' },
    { number: '24/7', label: 'Access Availability', icon: '🌐' }
  ];

  // Filtered downloads
  const filteredDownloads = activeCategory === 'all' 
    ? downloads 
    : downloads.filter(item => item.category === activeCategory);
  
  const searchedDownloads = filteredDownloads.filter(item => 
    item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.authors && item.authors.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Download handler
  const handleDownload = (item) => {
    console.log(`Downloading: ${item.title}`);
    // In real implementation, this would trigger actual file download
    alert(`Downloading: ${item.title}\nFile size: ${item.fileSize}\nFormat: ${item.fileType}`);
  };

  const handlePreview = (item) => {
    console.log(`Previewing: ${item.title}`);
    // In real implementation, this would open a PDF viewer
    alert(`Preview: ${item.title}\nThis would open the document in a new tab.`);
  };

  return (
    <div className="downloads-page">
      {/* Hero Section - Updated */}
      <section className="downloads-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Adam International Academy Resource Center</h1>
            <p>Access academic journals, annual reports, program brochures, catalogs, and application forms. All resources are free for download.</p>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">18</span>
                <span className="hero-stat-label">Resources</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">15K+</span>
                <span className="hero-stat-label">Downloads</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">4</span>
                <span className="hero-stat-label">Languages</span>
              </div>
            </div>
          </div>
          <div className="hero-graphic">
            <div className="graphic-item">
              <div className="icon">📚</div>
              <span>Journals</span>
            </div>
            <div className="graphic-item">
              <div className="icon">📊</div>
              <span>Reports</span>
            </div>
            <div className="graphic-item">
              <div className="icon">📄</div>
              <span>Brochures</span>
            </div>
            <div className="graphic-item">
              <div className="icon">📝</div>
              <span>Forms</span>
            </div>
          </div>
        </div>
      </section>

      {/* Search Section */}
      <section 
        className="downloads-search"
        ref={el => sectionRefs.current.search = el}
        data-section="search"
      >
        <div className={`container ${visibleSections.search ? 'visible' : ''}`}>
          <div className="search-container">
            <input 
              type="text" 
              placeholder="Search resources by title, description, or author..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
              aria-label="Search resources"
            />
            <button className="search-button" aria-label="Search">
              <span className="search-icon">🔍</span>
              Search
            </button>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section 
        className="downloads-categories"
        ref={el => sectionRefs.current.categories = el}
        data-section="categories"
      >
        <div className={`container ${visibleSections.categories ? 'visible' : ''}`}>
          <h2>Browse by Category</h2>
          <div className="categories-grid">
            {categories.map(category => (
              <div 
                key={category.id}
                className={`category-card ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => e.key === 'Enter' && setActiveCategory(category.id)}
                aria-label={`Filter by ${category.name}`}
              >
                <div className="category-icon">{category.icon}</div>
                <div className="category-info">
                  <h3>{category.name}</h3>
                  <p>{category.count} resources</p>
                </div>
                <div className="category-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Downloads Grid */}
      <section 
        className="downloads-grid-section"
        ref={el => sectionRefs.current.downloads = el}
        data-section="downloads"
      >
        <div className={`container ${visibleSections.downloads ? 'visible' : ''}`}>
          <div className="section-header">
            <h2>
              {activeCategory === 'all' ? 'All Resources' : categories.find(c => c.id === activeCategory)?.name}
              <span className="count-badge">{searchedDownloads.length} items</span>
            </h2>
            <p>Download academic publications, program information, and application forms</p>
          </div>

          {searchedDownloads.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">📭</div>
              <h3>No resources found</h3>
              <p>Try adjusting your search or filter criteria</p>
            </div>
          ) : (
            <div className="downloads-grid">
              {searchedDownloads.map(item => (
                <div key={item.id} className="download-card">
                  <div className="card-image">
                    <img src={item.image} alt={item.title} loading="lazy" />
                    <div className="file-type">{item.fileType}</div>
                    {item.issn && <div className="issn-badge">ISSN: {item.issn}</div>}
                  </div>
                  <div className="card-content">
                    <h3>{item.title}</h3>
                    <p>{item.description.substring(0, 120)}...</p>
                    {item.authors && (
                      <div className="authors">
                        <strong>Authors:</strong> {item.authors}
                      </div>
                    )}
                    <div className="file-details">
                      <span className="file-size">📄 {item.fileSize}</span>
                      <span className="download-count">⬇️ {item.downloads.toLocaleString()}</span>
                      <span className="publish-date">📅 {new Date(item.publishDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</span>
                    </div>
                    {item.pages && (
                      <div className="pages-info">
                        <span>📖 {item.pages} pages</span>
                      </div>
                    )}
                  </div>
                  <div className="card-actions">
                    <button 
                      className="download-button"
                      onClick={() => handleDownload(item)}
                      aria-label={`Download ${item.title}`}
                    >
                      <span className="download-icon">⬇️</span>
                      Download
                    </button>
                    <button 
                      className="preview-button"
                      onClick={() => handlePreview(item)}
                      aria-label={`Preview ${item.title}`}
                    >
                      <span className="preview-icon">👁️</span>
                      Preview
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Stats Section - Updated */}
      <section 
        className="downloads-stats"
        ref={el => sectionRefs.current.stats = el}
        data-section="stats"
      >
        <div className={`container ${visibleSections.stats ? 'visible' : ''}`}>
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Updated */}
      <section 
        className="downloads-cta"
        ref={el => sectionRefs.current.cta = el}
        data-section="cta"
      >
        <div className={`container ${visibleSections.cta ? 'visible' : ''}`}>
          <div className="cta-content">
            <h2>Need a specific resource?</h2>
            <p>Contact our documentation team for assistance with academic publications or program information</p>
            <div className="cta-buttons">
              <button className="btn primary">📧 Request Resource</button>
              <button className="btn outline">📞 Contact Support</button>
            </div>
            <div className="cta-contact">
              <p>📞 (+90) 380-772631 | ✉️ publications@adaminternationalacademy.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Downloads;